import * as React from "react";

function SvgAlertOctagon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 16.556V7.444L16.556 1H7.444L1 7.444v9.112L7.444 23h9.112L23 16.556zM8.272 3h7.456L21 8.272v7.456L15.728 21H8.272L3 15.728V8.272L8.272 3zM12 17.998a1 1 0 100-2 1 1 0 000 2zm1.004-12h-2.001v8h2v-8z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgAlertOctagon;
